import { render } from "./OptionIcon.vue?vue&type=template&id=6856765b&scoped=true"
const script = {}

import "./OptionIcon.vue?vue&type=style&index=0&id=6856765b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6856765b"]])

export default __exports__